import { FloorplanRevision } from '@thive/fddm-types';

export const FloorplanDesignSelector = {
  revisionIsInDraft: (state: FloorplanRevision): boolean => state.metaData.state === 'DRAFT',
  revisionIsLoaded: (state: FloorplanRevision): boolean => !!state.metaData.revisionId,
} as const;
